import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _backgroundMap;
import React, { useRef } from 'react';
import classNames from 'classnames/bind';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import { useHeaderIndent } from "../../hooks/useHeaderIndent";
import { useHeaderOverlayEffect, useOverlayEventListener } from "../../hooks/useDisableHeaderOverlay";
import { EHeaderTheme } from "../../store/slices/layout";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);

// TODO: Поменять на переменные --color-background-primary etc когда будет исправлен дефект с переопределением темы
var backgroundMap = (_backgroundMap = {}, _defineProperty(_backgroundMap, EHeaderTheme.primary, '#f0f3f5'), _defineProperty(_backgroundMap, EHeaderTheme.secondary, '#fff'), _defineProperty(_backgroundMap, EHeaderTheme.dark, '#191c22'), _backgroundMap);
var Section = function Section(_ref) {
  var className = _ref.className,
    gap = _ref.gap,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? 'equal-columns' : _ref$view,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("section", {
    className: cn('section', "section__gap--".concat(gap), "section__view--".concat(view), className),
    "data-t-id": "components-Layout"
  }, children);
};
var Wrapper = function Wrapper(_ref2) {
  var className = _ref2.className,
    _ref2$position = _ref2.position,
    position = _ref2$position === void 0 ? 'center' : _ref2$position,
    _ref2$gap = _ref2.gap,
    gap = _ref2$gap === void 0 ? 'm' : _ref2$gap,
    fullWidth = _ref2.fullWidth,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper', "wrapper__position--".concat(position), "wrapper__gap--".concat(gap), {
      wrapper__fullWidth: fullWidth
    }, className)
  }, children);
};
var Container = function Container(_ref3) {
  var className = _ref3.className,
    children = _ref3.children,
    _ref3$position = _ref3.position,
    position = _ref3$position === void 0 ? 'fixed' : _ref3$position,
    headerTheme = _ref3.headerTheme,
    transparent = _ref3.transparent,
    overlayDisabled = _ref3.overlayDisabled;
  var elementRef = useRef(null);
  useHeaderIndent(elementRef);
  useHeaderOverlayEffect(elementRef, overlayDisabled, !transparent);
  useOverlayEventListener();
  return /*#__PURE__*/React.createElement("div", {
    className: cn('container', "container-theme--".concat(headerTheme), "container-position--".concat(position), {
      'container-transparent': transparent
    }, className),
    "data-component": "site-header-container",
    ref: elementRef
  }, children);
};
var Indent = function Indent(_ref4) {
  var className = _ref4.className,
    children = _ref4.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('indent', className)
  }, children);
};
export var Layout = function Layout(_ref5) {
  var className = _ref5.className,
    _ref5$headerTheme = _ref5.headerTheme,
    headerTheme = _ref5$headerTheme === void 0 ? EHeaderTheme.secondary : _ref5$headerTheme,
    gap = _ref5.gap,
    children = _ref5.children;
  var documentStyleSheet = "html, body { background: ".concat(backgroundMap[headerTheme], " !important }");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", {
    className: cn('layout', "layout__gap--".concat(gap), className, cnComponentsTheme('light')),
    "data-component": "site-header",
    role: "navigation"
  }, children), /*#__PURE__*/React.createElement("style", null, documentStyleSheet));
};
Layout.Container = Container;
Layout.Section = Section;
Layout.Wrapper = Wrapper;
Layout.Indent = Indent;